document.addEventListener("DOMContentLoaded", function () {
  const checkEllipsis = () => {
    document
      .querySelectorAll("*[data-textellipsis-toggler]")
      .forEach((container) => {
        const showButton =
          container.scrollHeight > container.clientHeight ||
          !container.classList.contains("text-ellipsis");
        const button = document.getElementById(
          container.getAttribute("data-textellipsis-toggler")
        );

        if (showButton) {
          button.classList.remove("hidden");
        } else {
          button.classList.add("hidden");
        }
      });
  };

  document
    .querySelectorAll("*[data-textellipsis-toggle][data-show-text]")
    .forEach((button) => {
      button.addEventListener("click", () => {
        const text = document.getElementById(
          button.getAttribute("data-textellipsis-toggle")
        );
        const showText = text.classList.contains("text-ellipsis");

        if (showText) {
          text.classList.remove("text-ellipsis");
          text.classList.remove("line-clamp-4");
        } else {
          text.classList.add("text-ellipsis");
          text.classList.add("line-clamp-4");
        }

        button.innerText = showText
          ? button.getAttribute("data-hide-text")
          : button.getAttribute("data-show-text");
      });
    });

  checkEllipsis();
});
